import axios from 'axios';

function getSearchEndpoint() {
    return window.OPTIONS.properties
        ? window.OPTIONS.properties['search.api.endpoint']
        : window.OPTIONS['nikeone']['nikeSearchSvcEndpoint'];
}

export const searchClient = axios.create({
    baseURL: getSearchEndpoint()
});
searchClient.interceptors.response.use(response => response.data);
